import { Paragraph } from "theme-ui"

export default function LegendLabel({ children, ...otherProps }) {
  return (
    <Paragraph color="blue" variant="label" {...otherProps}>
      {children}
    </Paragraph>
  )
}
